// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__juL0E","vLegacy":"SelectSecondary_vLegacy__37j1M","error":"SelectSecondary_error__35rsI","disabled":"SelectSecondary_disabled__2XyuC"};